export default __webpack_public_path__ + "static/miceBanner2_768-5e8103db7a2e48e04f1749c5041340c5.jpg";